<template>
  <svg width="311" height="6" viewBox="0 0 311 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="71.75" height="6" rx="3" fill="#991E66"/>
    <rect x="79.75" width="71.75" height="6" rx="3" fill="#D482B4"/>
    <rect x="159.5" width="71.75" height="6" rx="3" fill="#E8C8DC"/>
    <rect x="239.25" width="71.75" height="6" rx="3" fill="#F6E6F0"/>
  </svg>
</template>

<script>
export default {
  name: 'longDottedLine'
}
</script>

<style scoped>

</style>
